// extracted by mini-css-extract-plugin
export const content = "EndangeredSpeciesSearch-module--content--ch8GO";
export const wrapper = "EndangeredSpeciesSearch-module--wrapper--3X7P_";
export const graphic = "EndangeredSpeciesSearch-module--graphic--3PVs5";